import { render, staticRenderFns } from "./FileUploadMulti.vue?vue&type=template&id=710be0fc&scoped=true&"
import script from "./FileUploadMulti.vue?vue&type=script&lang=ts&"
export * from "./FileUploadMulti.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadMulti.vue?vue&type=style&index=0&id=710be0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710be0fc",
  null
  
)

export default component.exports